import type React from "react";
import type { CSSProperties } from "react";

/**
 * Calculates CSS custom properties for positioning the desktop navigation drawer.
 *
 * @param navigationRef - Ref to the parent navigation container
 * @param desktopNavRef - Ref to the desktop navigation element
 * @returns CSS custom properties for drawer positioning
 */
export const useDesktopDrawerOffsets = (
  navigationRef: React.RefObject<HTMLElement>,
  desktopNavRef: React.RefObject<HTMLDivElement>,
): CSSProperties => {
  const parentBox = navigationRef.current?.getBoundingClientRect();
  const desktopNavigationBox = desktopNavRef.current?.getBoundingClientRect();

  const parentTop = parentBox?.top ?? 0;
  const parentHeight = parentBox?.height ?? 0;
  const navHeight = desktopNavigationBox?.height ?? 0;
  const navLeft = desktopNavigationBox?.left ?? 0;

  const drawerOffset = parentTop + parentHeight;
  const barOffset = (parentHeight - navHeight) / 2;

  const divStyle = {
    "--drawer-offset": `${drawerOffset}px`,
    "--drawer-left-offset": `${navLeft}px`,
    "--bar-offset": `${barOffset}px`,
  } as CSSProperties;

  return divStyle;
};
